// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

import { getDictionaryTagById } from 'app/constants/enums/DictionaryTag/main';

/* eslint-disable max-len */
export const AMERICAN = getDictionaryTagById('american');
export const BRITISH = getDictionaryTagById('british');
export const DATED = getDictionaryTagById('dated');
export const FORMAL = getDictionaryTagById('formal');
export const INFORMAL = getDictionaryTagById('informal');
export const LITERARY = getDictionaryTagById('literary');
export const OFFENSIVE = getDictionaryTagById('offensive');
export const SLANG = getDictionaryTagById('slang');
/* eslint-enable max-len */
